import React, { Component } from "react";
//import AddCircleOutlineOutlinedIcon from "@material-ui/icons/AddCircleOutlineOutlined";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import { Button, Drawer } from "@material-ui/core";
// import Check from "../assets/check.png";
// import Cross from "..//assets/cross.png";

import SearchCampaign from "./SearchCampaign";
import AddCampaign from "../Form/AddNewForm";
import {
  addCampaignForm,
  campaignValidation,
  editcampaignValidation,
  editCampaignForm
} from "./CampaignConfig";

import "./campaign.css";
import "./editCampaign.css";
//import store from "../../Redux/Store";
import { fetchMethod } from "../../FetchMethod";
import { thCampaignsArray } from "../variables/THeaders";
import { CampaignInfo } from "../../Queries";
import ReactTableComponent from "../tables/ReactTable";
import "./CampaignActiveTab.css";
import CampaignTablesComponent from "./CampaignTables";

import { connect } from "react-redux";

import {
  getCampaignCustomers,
  getcampaignmanager,
  addNewCampaign,
  saveCampaignstep,
  getcampaignmanagerassignto,
  EditCampaignQuery
} from "../Campaign/campaignQueries";


class Campaign extends Component {
  constructor(props) {
    super(props);
    this.child = React.createRef();
    this.state = {
      search: "",
      header: "Campaign Management",
      loading: false,
      campaigns: [],
      custdata: [],
      custdata1: [],
      campmanager: [],
      campmanager1: [],
      linkedinProfile: [],
      addsteps: [],
      openForm: false,
      openEdit: false,
      clear: [],
      totalCount: 0,
      limit: 50,
      filterColumn: "",
      shortfilter: false,
      offset: 50,
      searchFlag: false,
      clickToSearch: false,
      showTab: false,
      campaignName: "",
      campaingnEditid: 0,
      campaignTempListData: [],
      editCampaignData: [],
      editCampaignStepsData: [],
      Row: [],
      assignTo: [],
      selected: {},
      campaignId: "",
      customerId: "",
      managerId: "",
      Status: "LIVE",
      lastResponse: undefined,
      customerfilter: "",
      campaignsProfile: [],
      linkedinid: "",
      datafromcampaign: "",
      salesNavigator: "",
      type: ""
    };
  }

  toggleDrawer = (side, open) => event => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    this.props.OnClear(this.state.clear);
    this.setState({ ...this.state, [side]: open });
  };

  setLinkedinData = data => {
    this.setState({ linkedinProfile: data });
  };

  componentDidMount() {
    localStorage.setItem("path", "/campaigns");
    const filter1 =
      localStorage.getItem("role") === "ADMIN"
        ? {
            where: {
              active: 1,
              createdby: localStorage.getItem("id"),
              order: "company asc"
            }
          }
        : { where: { active: 1, order: "company asc" } };
    fetchMethod(getCampaignCustomers, filter1)
      .then(res => res.json())
      .then(res => {
        this.setState({ custdata: res.data.allCustomers.Customers }, () => {});
      })
      .catch(e => console.log(e));

    const filter2 =
      localStorage.getItem("role") === "ADMIN"
        ? {
            where: {
              order: "company asc",
              createdby: localStorage.getItem("id")
            }
          }
        : { where: { order: "company asc" } };
    fetchMethod(getCampaignCustomers, filter2)
      .then(res => res.json())
      .then(res => {
        this.setState({ custdata1: res.data.allCustomers.Customers }, () => {});
      })
      .catch(e => console.log(e));

    const filter =
      localStorage.getItem("role") === "ADMIN"
        ? {
            where: {
              createdby: localStorage.getItem("id"),
              role: "CAMPAIGNMANAGER",
              status: 1,
              order: "firstName asc"
            }
          }
        : {
            where: {
              role: "CAMPAIGNMANAGER",
              status: 1,
              order: "firstName asc"
            }
          };

    fetchMethod(getcampaignmanager, filter)
      .then(res => res.json())
      .then(res => {
        let data =
          res.data.allUsersdata !== undefined && res.data.allUsersdata !== null
            ? res.data.allUsersdata.Usersdata
            : "";

        this.setState({ campmanager: data }, () => {});
      })
      .catch(e => console.log(e));

    const filter3 =
      localStorage.getItem("role") === "ADMIN"
        ? {
            where: {
              createdby: localStorage.getItem("id"),
              role: "CAMPAIGNMANAGER",
              order: "firstName asc"
            }
          }
        : {
            where: {
              role: "CAMPAIGNMANAGER",
              order: "firstName asc"
            }
          };

    fetchMethod(getcampaignmanager, filter3)
      .then(res => res.json())
      .then(res => {
        let data =
          res.data.allUsersdata !== undefined && res.data.allUsersdata !== null
            ? res.data.allUsersdata.Usersdata
            : "";

        this.setState({ campmanager1: data }, () => {});
      })
      .catch(e => console.log(e));

    fetchMethod(getcampaignmanagerassignto)
      .then(res => res.json())
      .then(res => {
        this.setState({ assignTo: res.data.allUsersdata.Usersdata }, () => {});
      })
      .catch(e => console.log(e));

    this.props.onHandleSidebarText("/campaigns");
  }

  setListData = response => {
    this.setState({
      campaigns: response.data.allCampaigns.Campaigns,
      totalCount: response.data.allCampaigns.totalCount
    });
  };

  SetLimit = limit => {
    this.setState({
      limit
    });
  };

  SetOffset = offset => {
    this.setState({ offset });
  };

  SearchClick = () => {
    if (this.state.searchFlag === true) {
      this.setState({ clickToSearch: true }, () => {
        this.child.current.searchFetch(this.state.limit, this.state.offset);
      });
    } else {
      this.setState({ clickToSearch: false }, () => {
        this.child.current.searchFetch(this.state.limit, this.state.offset);
      });
    }
  };

  setCampaignRowClick = rowInfo => {};

  backToCampaignList = () => {
    this.props.onHandleCampaign();
    this.setState(
      {
        showTab: false,
        customerId: "",
        search: "",
        managerId: "",
        Status: "LIVE"
      },
      () => {
        this.props.LastResponse(this.state.lastResponse);
      }
    );
    this.props.onEditMode(false);
  };

  setmanagerId = response => {
    response === "Select"
      ? this.setState({ managerId: "" })
      : this.setState(
          {
            managerId: response
          },
          () => {
            this.child.current.searchFetch(this.state.limit, this.state.offset);
          }
        );
  };

  NameFilter = () => {
    this.setState({ filterColumn: "name asc", shortfilter: true }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  NameFilter1 = () => {
    this.setState({ filterColumn: "name desc", shortfilter: false }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };

  StatusFilter = () => {
    this.setState({ filterColumn: "status asc", shortfilter: true }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  StatusFilter1 = () => {
    this.setState({ filterColumn: "status desc", shortfilter: false }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };

  DateFilter = () => {
    this.setState({ filterColumn: "startdate asc", shortfilter: true }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  DateFilter1 = () => {
    this.setState({ filterColumn: "startdate desc", shortfilter: false }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
    RunFilter = () => {
    this.setState({ filterColumn: "runningcampaign asc", shortfilter: true }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  RunFilter1 = () => {
    this.setState({ filterColumn: "runningcampaign desc", shortfilter: false }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };

  statusChange = response => {
    this.setState(
      {
        Status: response
      },
      () => {
        this.child.current.searchFetch(this.state.limit, this.state.offset);
      }
    );
  };
  setCustomerId = response => {
    this.setState({ customerId: response }, () => {
      this.child.current.searchFetch(this.state.limit, this.state.offset);
    });
  };
  handleSearchChange = response => {
    this.setState({ search: response });
  };
  handleSearch = response => {
    this.setState({ searchFlag: response }, () => this.SearchClick());
  };
  handleonclickSearch = response => {
    this.setState({ clickToSearch: response });
  };

  onNameClick = campaigns => {
    this.setState({ Row: campaigns });
   
    this.setState({
      showTab: true,
      campaignName: campaigns.name,
      campaignStatus: campaigns.status,
      campaignId: campaigns.id,
      customerId: campaigns.customerid,
      linkedinid: campaigns.linkedinid,
      datafromcampaign: campaigns.datafromcampaign,
      salesNavigator: campaigns.salesNavigator,
      type: campaigns.type
    });
    this.props.formData.status = campaigns.status;
  };

  render() {
    const search = this.state.clickToSearch ? this.state.search : "";
    const like = `%${search}%`;
    const filter =
      localStorage.getItem("role") === "ADMIN"
        ? this.state.Status === "ALL"
          ? this.state.customerId !== "All" &&
            this.state.customerId !== "" &&
            this.state.managerId !== "All" &&
            this.state.managerId !== ""
            ? {
                where: {
                  campaignadminid: localStorage.getItem("id"),
                  customerid: this.state.customerId,
                  campaignmanagerid: this.state.managerId,
                  order: this.state.filterColumn,
                  and: [
                    {
                      or: [{ name: { like: like, options: "i" } }]
                    }
                  ]
                }
              }
            : this.state.customerId !== "All" && this.state.customerId !== ""
            ? {
                where: {
                  campaignadminid: localStorage.getItem("id"),
                  customerid: this.state.customerId,
                  order: this.state.filterColumn,
                  and: [
                    {
                      or: [{ name: { like: like, options: "i" } }]
                    }
                  ]
                }
              }
            : this.state.managerId !== "All" && this.state.managerId !== ""
            ? {
                where: {
                  campaignadminid: localStorage.getItem("id"),
                  campaignmanagerid: this.state.managerId,
                  order: this.state.filterColumn,
                  and: [
                    {
                      or: [{ name: { like: like, options: "i" } }]
                    }
                  ]
                }
              }
            : {
                where: {
                  campaignadminid: localStorage.getItem("id"),
                  order: this.state.filterColumn,
                  and: [
                    {
                      or: [{ name: { like: like, options: "i" } }]
                    }
                  ]
                }
              }
          : this.state.customerId !== "All" &&
            this.state.customerId !== "" &&
            this.state.managerId !== "All" &&
            this.state.managerId !== ""
          ? {
              where: {
                campaignadminid: localStorage.getItem("id"),
                customerid: this.state.customerId,
                campaignmanagerid: this.state.managerId,
                order: this.state.filterColumn,
                status: this.state.Status,
                active: 1,
                and: [
                  {
                    or: [{ name: { like: like, options: "i" } }]
                  }
                ]
              }
            }
          : this.state.customerId !== "All" && this.state.customerId !== ""
          ? {
              where: {
                campaignadminid: localStorage.getItem("id"),
                status: this.state.Status,
                active: 1,
                customerid: this.state.customerId,
                order: this.state.filterColumn,
                and: [
                  {
                    or: [{ name: { like: like, options: "i" } }]
                  }
                ]
              }
            }
          : this.state.managerId !== "All" && this.state.managerId !== ""
          ? {
              where: {
                campaignadminid: localStorage.getItem("id"),
                status: this.state.Status,
                active: 1,
                campaignmanagerid: this.state.managerId,
                order: this.state.filterColumn,
                and: [
                  {
                    or: [{ name: { like: like, options: "i" } }]
                  }
                ]
              }
            }
          : {
              where: {
                campaignadminid: localStorage.getItem("id"),
                status: this.state.Status,
                active: 1,
                order: this.state.filterColumn,
                and: [
                  {
                    or: [{ name: { like: like, options: "i" } }]
                  }
                ]
              }
            }
        : localStorage.getItem("role") === "CUSTOMER"
        ? this.state.Status === "ALL"
          ? this.state.customerId !== "All" &&
            this.state.customerId !== "" &&
            this.state.managerId !== "All" &&
            this.state.managerId !== ""
            ? {
                where: {
                  customerid: localStorage.getItem("customer"),
                  campaignmanagerid: this.state.managerId,
                  order: this.state.filterColumn,
                  and: [
                    {
                      or: [{ name: { like: like, options: "i" } }]
                    }
                  ]
                }
              }
            : this.state.customerId !== "All" && this.state.customerId !== ""
            ? {
                where: {
                  customerid: localStorage.getItem("customer"),
                  order: this.state.filterColumn,
                  and: [
                    {
                      or: [{ name: { like: like, options: "i" } }]
                    }
                  ]
                }
              }
            : this.state.managerId !== "All" && this.state.managerId !== ""
            ? {
                where: {
                  customerid: localStorage.getItem("customer"),
                  campaignmanagerid: this.state.managerId,
                  order: this.state.filterColumn,
                  and: [
                    {
                      or: [{ name: { like: like, options: "i" } }]
                    }
                  ]
                }
              }
            : {
                where: {
                  customerid: localStorage.getItem("customer"),
                  order: this.state.filterColumn,
                  and: [
                    {
                      or: [{ name: { like: like, options: "i" } }]
                    }
                  ]
                }
              }
          : this.state.customerId !== "All" &&
            this.state.customerId !== "" &&
            this.state.managerId !== "All" &&
            this.state.managerId !== ""
          ? {
              where: {
                customerid: localStorage.getItem("customer"),
                campaignmanagerid: this.state.managerId,
                order: this.state.filterColumn,
                status: this.state.Status,
                active: 1,
                and: [
                  {
                    or: [{ name: { like: like, options: "i" } }]
                  }
                ]
              }
            }
          : this.state.customerId !== "All" && this.state.customerId !== ""
          ? {
              where: {
                status: this.state.Status,
                active: 1,
                customerid: localStorage.getItem("customer"),
                order: this.state.filterColumn,
                and: [
                  {
                    or: [{ name: { like: like, options: "i" } }]
                  }
                ]
              }
            }
          : this.state.managerId !== "All" && this.state.managerId !== ""
          ? {
              where: {
                customerid: localStorage.getItem("customer"),
                status: this.state.Status,
                active: 1,
                campaignmanagerid: this.state.managerId,
                order: this.state.filterColumn,
                and: [
                  {
                    or: [{ name: { like: like, options: "i" } }]
                  }
                ]
              }
            }
          : {
              where: {
                customerid: localStorage.getItem("customer"),
                status: this.state.Status,
                active: 1,
                order: this.state.filterColumn,
                and: [
                  {
                    or: [{ name: { like: like, options: "i" } }]
                  }
                ]
              }
            }
        : localStorage.getItem("role") === "CAMPAIGNMANAGER"
        ? this.state.Status === "ALL"
          ? this.state.customerId !== "All" &&
            this.state.customerId !== "" &&
            this.state.managerId !== "All" &&
            this.state.managerId !== ""
            ? {
                where: {
                  customerid: this.state.customerId,
                  campaignmanagerid: localStorage.getItem("id"),
                  order: this.state.filterColumn,
                  and: [
                    {
                      or: [{ name: { like: like, options: "i" } }]
                    }
                  ]
                }
              }
            : this.state.customerId !== "All" && this.state.customerId !== ""
            ? {
                where: {
                  campaignmanagerid: localStorage.getItem("id"),
                  customerid: this.state.customerId,
                  order: this.state.filterColumn,
                  and: [
                    {
                      or: [{ name: { like: like, options: "i" } }]
                    }
                  ]
                }
              }
            : this.state.managerId !== "All" && this.state.managerId !== ""
            ? {
                where: {
                  campaignmanagerid: localStorage.getItem("id"),
                  order: this.state.filterColumn,
                  and: [
                    {
                      or: [{ name: { like: like, options: "i" } }]
                    }
                  ]
                }
              }
            : {
                where: {
                  campaignmanagerid: localStorage.getItem("id"),
                  order: this.state.filterColumn,
                  and: [
                    {
                      or: [{ name: { like: like, options: "i" } }]
                    }
                  ]
                }
              }
          : this.state.customerId !== "All" &&
            this.state.customerId !== "" &&
            this.state.managerId !== "All" &&
            this.state.managerId !== ""
          ? {
              where: {
                customerid: this.state.customerId,
                campaignmanagerid: localStorage.getItem("id"),
                order: this.state.filterColumn,
                status: this.state.Status,
                active: 1,
                and: [
                  {
                    or: [{ name: { like: like, options: "i" } }]
                  }
                ]
              }
            }
          : this.state.customerId !== "All" && this.state.customerId !== ""
          ? {
              where: {
                status: this.state.Status,
                active: 1,
                campaignmanagerid: localStorage.getItem("id"),
                customerid: this.state.customerId,
                order: this.state.filterColumn,
                and: [
                  {
                    or: [{ name: { like: like, options: "i" } }]
                  }
                ]
              }
            }
          : this.state.managerId !== "All" && this.state.managerId !== ""
          ? {
              where: {
                status: this.state.Status,
                active: 1,
                campaignmanagerid: localStorage.getItem("id"),
                order: this.state.filterColumn,
                and: [
                  {
                    or: [{ name: { like: like, options: "i" } }]
                  }
                ]
              }
            }
          : {
              where: {
                campaignmanagerid: localStorage.getItem("id"),
                status: this.state.Status,
                active: 1,
                order: this.state.filterColumn,
                and: [
                  {
                    or: [{ name: { like: like, options: "i" } }]
                  }
                ]
              }
            }
        : this.state.Status === "ALL"
        ? this.state.customerId !== "All" &&
          this.state.customerId !== "" &&
          this.state.managerId !== "All" &&
          this.state.managerId !== ""
          ? {
              where: {
                customerid: this.state.customerId,
                campaignmanagerid: this.state.managerId,
                order: this.state.filterColumn,
                and: [
                  {
                    or: [{ name: { like: like, options: "i" } }]
                  }
                ]
              }
            }
          : this.state.customerId !== "All" && this.state.customerId !== ""
          ? {
              where: {
                customerid: this.state.customerId,
                order: this.state.filterColumn,
                and: [
                  {
                    or: [{ name: { like: like, options: "i" } }]
                  }
                ]
              }
            }
          : this.state.managerId !== "All" && this.state.managerId !== ""
          ? {
              where: {
                campaignmanagerid: this.state.managerId,
                order: this.state.filterColumn,
                and: [
                  {
                    or: [{ name: { like: like, options: "i" } }]
                  }
                ]
              }
            }
          : {
              where: {
                order: this.state.filterColumn,
                and: [
                  {
                    or: [{ name: { like: like, options: "i" } }]
                  }
                ]
              }
            }
        : this.state.customerId !== "All" &&
          this.state.customerId !== "" &&
          this.state.managerId !== "All" &&
          this.state.managerId !== ""
        ? {
            where: {
              customerid: this.state.customerId,
              campaignmanagerid: this.state.managerId,
              order: this.state.filterColumn,
              status: this.state.Status,
              active: 1,
              and: [
                {
                  or: [{ name: { like: like, options: "i" } }]
                }
              ]
            }
          }
        : this.state.customerId !== "All" && this.state.customerId !== ""
        ? {
            where: {
              status: this.state.Status,
              active: 1,
              customerid: this.state.customerId,
              order: this.state.filterColumn,
              and: [
                {
                  or: [{ name: { like: like, options: "i" } }]
                }
              ]
            }
          }
        : this.state.managerId !== "All" && this.state.managerId !== ""
        ? {
            where: {
              status: this.state.Status,
              active: 1,
              campaignmanagerid: this.state.managerId,
              order: this.state.filterColumn,
              and: [
                {
                  or: [{ name: { like: like, options: "i" } }]
                }
              ]
            }
          }
        : {
            where: {
              status: this.state.Status,
              active: 1,
              order: this.state.filterColumn,
              and: [
                {
                  or: [{ name: { like: like, options: "i" } }]
                }
              ]
            }
          };
    const filterSort = [
      {
        Header: "Customer",
        accessor: "Customer"
      },
      {
        Header: "Profile",
        accessor: "Profile"
      },
      {
        Header: obj => {
          return (
            <div
              className="Name"
              style={{ cursor: "pointer" }}
              onClick={
                this.state.shortfilter !== true
                  ? this.NameFilter
                  : this.NameFilter1
              }
            >
              Campaign
            </div>
          );
        },
        accessor: "Name"
      },

      {
        Header: obj => {
          return (
            <div
              className="Name"
              style={{ cursor: "pointer" }}
              onClick={
                this.state.shortfilter !== true
                  ? this.StatusFilter
                  : this.StatusFilter1
              }
            >
              Status
            </div>
          );
        },
        accessor: "status",
        Cell: row => {
         
          row.styles["color"] =
            row.value === "LIVE"
              ? "#03AC58"
              : row.value === "PAUSED"
              ? "#FFA500"
              : row.value === "COMPLETED"
              ? "#00ff00"
              : "grey";

          return row.value;
        }
      },
      {
        Header: obj => {
          return (
            <div
              className="Name"
              style={{ cursor: "pointer" }}
              onClick={
                this.state.shortfilter !== true
                  ? this.DateFilter
                  : this.DateFilter1
              }
            >
              Start Date
            </div>
          );
        },
        accessor: "startDate"
      },
      {
        Header: obj => {
          return (
            <div
              className="Name"
              style={{ cursor: "pointer" }}
              onClick={
                this.state.shortfilter !== true
                  ? this.RunFilter
                  : this.RunFilter1
              }
            >
              Running
            </div>
          );
        },
        accessor: "runonWeb"
      },
      {
       Header: "# Invites",
       accessor: "invitedcount"
      },
      {
        Header: "# Connected",
        accessor: "connectedcount"
      },
      {
        Header: "% Connected",
        accessor: "connectedper"
      },
        {
    Header: "# Engaged",
    accessor: "engagedcount"
  },
    {
    Header: "% Engaged",
    accessor: "engagedper"
  },
    {
    Header: "# Leads",
    accessor: "leadcount"
  },
  {
    Header: "% Leads",
    accessor: "leadper"
  }
    ];
    let campaigns = [...this.state.campaigns];
    campaigns.map(campaigns => {
      let date = campaigns.startdate
        .split("T")[0]
        .split("-")
        .reverse()
        .join("/");
      let datearray = date.split("/");
      campaigns.startDate =
        datearray[0] + "/" + datearray[1] + "/" + datearray[2];

      campaigns.Name = (
        <div
          style={{ cursor: "pointer", height: "35px" }}
          onClick={() => {
            this.onNameClick(campaigns);
          }}
        >
          {campaigns.name}
        </div>
      );

      campaigns.Customer =
        campaigns.customerIbfk1rel !== undefined &&
        campaigns.customerIbfk1rel !== null
          ? campaigns.customerIbfk1rel.Customers.map(company => {
              return (
                <div
                  style={{ cursor: "pointer", height: "35px" }}
                  onClick={() => {
                    this.onNameClick(campaigns);
                  }}
                >
                  {company.company}
                </div>
              );
            })
          : "";

      if (
        campaigns.runningCampaign == undefined ||
        campaigns.runningCampaign == null ||
        campaigns.runningCampaign == ""
      ) {
        campaigns.runonWeb = (
          <div className="onffSwitchmonitor2">
       
            <FiberManualRecordIcon
              checked={campaigns.runningCampaign == 1 ? true : false}
              name="checkedA"
            />
          </div>
        );
      } else {
        campaigns.runonWeb = (
          <div className="onffSwitchmonitor3">
       
            <FiberManualRecordIcon
              checked={campaigns.runningCampaign == 1 ? true : false}
              name="checkedA"
            />
          </div>
        );
      }



      campaigns.Profile =
        campaigns.customercredentialsIbfk1rel !== undefined &&
        campaigns.customercredentialsIbfk1rel !== null
          ? campaigns.customercredentialsIbfk1rel.Customerlinkedinprofiles.map(
              name => {
                return (
                  <div
                    style={{ cursor: "pointer", height: "35px" }}
                    onClick={() => {
                      this.onNameClick(campaigns);
                    }}
                  >
                    {name.name}
                  </div>
                );
              }
            )
          : "";



      return null;
    });

    return (
      <div className="Campaign">
        {this.state.showTab || this.props.campaignProps ? (
          <CampaignTablesComponent
            ref={this.child}
            campaignid={
              this.state.campaignId || this.props.campaignProps.campaignid
            }
            customerid={this.state.customerId}
            linkedinid={this.state.linkedinid}
            datafromcampaign={this.state.datafromcampaign}
            salesNavigator={this.state.salesNavigator}
            type={this.state.type}
            backToCampaignMainList={this.backToCampaignList}
            selectedCampaignName={this.state.campaignName}
            // selectedCampaignStatus={
            //   this.state.campaignStatus ||
            //   this.props.campaignProps.selectedCampaignStatus
            // }
            selectedCampaignStatus={
              this.props.formData.status === undefined
                ? "LIVE"
                : this.props.formData.status
            }
            // toggleDrawer={this.toggleDrawer("openEdit", true, this.state.Row)}
            open={this.state.openEdit}
            onOpen={this.toggleDrawer("openEdit", true)}
            formConfig={editCampaignForm}
            editableData={this.props.formData}
            editLinkedinData={this.state.editCampaignStepsData}
            formValidation={editcampaignValidation}
            modalClose={this.toggleDrawer("openEdit", false, this.state.Row)}
            query={EditCampaignQuery}
            getData={this.setLinkedinData}
            params={this.state.custdata1}
            params1={this.state.campmanager1}
            params2={this.state.linkedinProfile}
            params3={this.state.assignTo}
          />
        ) : (
          <React.Fragment>
            <div className="top-flexbox">
              <div className="title-block">
                <h1>Campaigns</h1>
                Total <span>{this.state.totalCount} Records</span>
              </div>
              <div className="button-block">
                {localStorage.getItem("role") !== "CUSTOMER" &&
                localStorage.getItem("role") !== "CAMPAIGNMANAGER" ? (
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={this.toggleDrawer("openForm", true)}
                    className="addButton"
                  
                  >
                    N<span style={{ textTransform: "lowercase" }}>ew</span>{" "}
                    &nbsp;C
                    <span style={{ textTransform: "lowercase" }}>ampaign</span>
                  </Button>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div className="modalButton">
              <SearchCampaign
                AdminId={this.setAdminId}
                ManagerId={this.setmanagerId}
                Status={this.statusChange}
                CustomerId={this.setCustomerId}
                onHandleSearchChange={this.handleSearchChange}
                onhandleSearch={this.handleSearch}
                onHandleClickSearch={this.handleonclickSearch}
                totalCount={this.state.totalCount}
                limit={this.state.limit}
                offset={this.state.offset}
              />

              <Drawer
                anchor="right"
                open={this.state.openForm}
                className="campManagmentDrawer"
              >
                <AddCampaign
                  title="Add Campaign"
                  formConfig={addCampaignForm}
                  modalClose={this.toggleDrawer("openForm", false)}
                  formValidation={campaignValidation}
                  params={this.state.custdata}
                  params1={this.state.campmanager}
                  query={addNewCampaign}
                  query1={saveCampaignstep}
                  className={"campaignForm"}
                  buttonName={"Save"}
                  getData={this.setLinkedinData}
                  params2={this.state.linkedinProfile}
                  params3={this.state.campaignsProfile}
                  message="New Campaign added successfully"
                  updateData={() =>
                    this.child.current.searchFetch(
                      this.state.limit,
                      this.state.offset
                    )
                  }
                  storeArray="addModalStep"
                />
              </Drawer>
            </div>
            <ReactTableComponent
              ref={this.child}
              listData={this.state.campaigns}
              listConfig={filterSort.concat(thCampaignsArray)}
              setData={this.setListData}
              query={CampaignInfo}
              totalCount={this.state.totalCount}
              setLimit={this.SetLimit}
              setOffset={this.SetOffset}
              filter={filter}
              onRowClick={() => {}}
              clickToSearch={this.state.clickToSearch}
            />
          </React.Fragment>
        )}
      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
    showTab: state.showTab,
    formData: state.formData,
    campaignProps: state.campaignDetail
  };
};

const mapDispatchToProps = dispatch => {
  
  return {
    editFormData: data => dispatch({ type: "Form_data", payload: data }),
    OnEdit: editCampaignStepsData =>
      dispatch({ type: "Edit_Step_Data", StepId: editCampaignStepsData }),
    OnClear: clear => dispatch({ type: "Clear_ADD_STEP", stepData: clear }),
    onEditMode: editMode =>
      dispatch({ type: "IsEditModeable", editMode: editMode }),
    getId: id => dispatch({ type: "GetId", id: id }),
    onHandleSidebarText: data =>
      dispatch({
        type: "HANDLE_SIDEBAR_TEXT",
        payload: data
      }),
    LastResponse: response =>
      dispatch({ type: "Last_Response", payload: response }),
    Customer_Filter: filter =>
      dispatch({ type: "Customer_Filter", payload: filter }),
    onHandleCampaign: data =>
      dispatch({ type: "Campaign_Detail", payload: null })
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Campaign);
